import React from "react";

function SectionHeading({
    eyebrow,
    title,
    subtitle,
}: {
    eyebrow?: string;
    title: string;
    subtitle?: string;
}) {
    return (
        <div className="mx-auto mb-10 max-w-3xl text-center">
            {eyebrow ? (
                <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs text-white/70">
                    <span className="h-2 w-2 rounded-full bg-white/60" />
                    {eyebrow}
                </div>
            ) : null}
            <h2 className="text-balance text-2xl font-semibold tracking-tight text-white sm:text-3xl">
                {title}
            </h2>
            {subtitle ? (
                <p className="mt-3 text-pretty text-sm text-white/70 sm:text-base">{subtitle}</p>
            ) : null}
        </div>
    );
}

export default function Audience() {
    const cards = [
        {
            title: "Właściciele serwerów",
            desc: "Preset konfiguracji + szybkie wdrożenie. Kontrola modułów per serwer.",
        },
        {
            title: "Moderatorzy",
            desc: "Narzędzia, logi i automaty. Mniej ręcznej pracy, mniej chaosu.",
        },
        {
            title: "Community & twórcy",
            desc: "Leveling, nagrody i eventy. Więcej aktywności i zaangażowania.",
        },
    ];

    return (
        <section id="dla-kogo" className="mx-auto max-w-6xl px-4 py-16 sm:px-6">
            <SectionHeading
                eyebrow="Dla kogo"
                title="Sprawdza się w każdym community"
                subtitle="Od małych serwerów po duże społeczności z zespołem moderatorów."
            />

            <div className="grid gap-4 md:grid-cols-3">
                {cards.map((c) => (
                    <div
                        key={c.title}
                        className="rounded-3xl border border-white/10 bg-white/5 p-6 backdrop-blur"
                    >
                        <div className="text-sm font-semibold text-white">{c.title}</div>
                        <p className="mt-2 text-sm text-white/70">{c.desc}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}
